// extracted by mini-css-extract-plugin
export default {"success":"Success_success__0Yr3k"};